module.exports = __webpack_public_path__ + "img/cardPic.8033e933.png";